import { motion } from "framer-motion";
import {
  Trophy,
  Speaker,
  ClipboardList,
  Users,
  Clock,
  MessageSquare,
  ShieldCheck,
  Megaphone,
} from "lucide-react";

const POINTS = [
  { icon: <Trophy size={22} />, title: "20 ans d'expérience", text: "Une expertise terrain construite soirée après soirée." },
  { icon: <Speaker size={22} />, title: "Matériel professionnel", text: "Sono et éclairage haut de gamme, fiables, premium." },
  { icon: <ClipboardList size={22} />, title: "Préparation personnalisée", text: "Brief, playlist, timing : tout est pensé avec vous." },
  { icon: <Users size={22} />, title: "Ambiance toutes générations", text: "Du grand-père de 80 ans aux ados : tout le monde danse." },
  { icon: <Clock size={22} />, title: "Gestion du timing", text: "Cérémonie, repas, animations : aucun temps mort." },
  { icon: <MessageSquare size={22} />, title: "Conseils avant l'événement", text: "Recommandations sur prestataires, format, déroulé." },
  { icon: <ShieldCheck size={22} />, title: "Présence rassurante le jour J", text: "Vous profitez. Je gère tout, en coulisses." },
  { icon: <Megaphone size={22} />, title: "Image pro & visibilité", text: "Une marque forte qui valorise aussi votre événement." },
];

export const WhyMe = () => {
  return (
    <section
      id="why"
      data-testid="why-choose-me-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[var(--bg-surface)] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow">Pourquoi me choisir</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Vous ne réservez pas un DJ. <br className="hidden md:block" />
            <span className="gold-text-gradient">Vous réservez votre tranquillité.</span>
          </h2>
          <p className="mt-4 text-zinc-400">
            Le jour J, vous voulez profiter — pas gérer. Mon métier, c'est que tout
            roule en coulisses, pour que vous viviez chaque émotion à fond.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`why-${p.title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "")}`}
              className="glass rounded-2xl p-6 hover:-translate-y-1 hover:border-[#D4AF37]/30 transition-all duration-300"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#D4AF37]/20 to-[#2D6CFF]/10 text-[#D4AF37] mb-5">
                {p.icon}
              </div>
              <h3 className="text-base font-semibold text-white">{p.title}</h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
